import {
  Anchor,
  BatteryChargingFull,
  BeachAccess,
  CabinOutlined,
  DirectionsBoatOutlined,
  ElectricalServices,
  ExploreOutlined,
  Inventory2Outlined,
  KitchenOutlined,
  PhoneAndroidOutlined,
  GpsFixed,
  WcOutlined,
  RadioOutlined,
  SecurityOutlined,
  ShowerOutlined,
  StairsOutlined,
  AirOutlined,
  ThermostatOutlined,
  WavesOutlined,
  CheckCircleOutline
} from '@mui/icons-material';

const ICON_RULES = [
  { re: /lodówk|chłodnic|kuchenk|kuchen|gazow|kambuz|aneks/i, Icon: KitchenOutlined },
  { re: /ogrzew|temperatur|ciepł/i, Icon: ThermostatOutlined },
  { re: /prysznic|woda pitna|woda\b|ciepła woda/i, Icon: ShowerOutlined },
  { re: /wc\b|toalet|muszla/i, Icon: WcOutlined },
  { re: /echosond|gps|nawigac|ster strumien|bulawa/i, Icon: ExploreOutlined },
  { re: /koło sterowe|ster\b|rufa|dziób/i, Icon: DirectionsBoatOutlined },
  { re: /kabestan|winda|roll fok|lazy|żagl|maszt|ożaglow/i, Icon: Anchor },
  { re: /drabink|schod/i, Icon: StairsOutlined },
  { re: /bimini|szprycbuda|sprayhood|kokpit/i, Icon: BeachAccess },
  { re: /12\s*v|230\s*v|elektryczn|gniazd|ładowani/i, Icon: ElectricalServices },
  { re: /telefon|usb/i, Icon: PhoneAndroidOutlined },
  { re: /radi[oó]|audio/i, Icon: RadioOutlined },
  { re: /relung|reluing/i, Icon: Inventory2Outlined },
  { re: /środki ratunk|kamizelk|asekuracyjn/i, Icon: SecurityOutlined },
  { re: /ubezpieczen/i, Icon: SecurityOutlined },
  { re: /kadłub|burty|pokład/i, Icon: DirectionsBoatOutlined },
  { re: /silnik|napęd/i, Icon: WavesOutlined },
  { re: /kabin|koj/i, Icon: CabinOutlined },
  { re: /wentyl|dmuchaw|ogrzew.*powietrz/i, Icon: AirOutlined },
  { re: /radar|plotter/i, Icon: GpsFixed },
  { re: /akumulator|bateri/i, Icon: BatteryChargingFull }
];

export function EquipmentFeatureIcon({ label, sx = {} }) {
  const t = (label || '').toLowerCase();
  for (const { re, Icon } of ICON_RULES) {
    if (re.test(t)) {
      return (
        <Icon
          sx={{
            fontSize: 24,
            color: 'text.primary',
            opacity: 0.88,
            flexShrink: 0,
            ...sx
          }}
        />
      );
    }
  }

  return (
    <CheckCircleOutline
      sx={{
        fontSize: 24,
        color: 'text.primary',
        opacity: 0.5,
        flexShrink: 0,
        ...sx
      }}
    />
  );
}
